import { render, staticRenderFns } from "./ButtonSecondary.vue?vue&type=template&id=649d3052&scoped=true&"
import script from "./ButtonSecondary.vue?vue&type=script&lang=js&"
export * from "./ButtonSecondary.vue?vue&type=script&lang=js&"
import style0 from "./ButtonSecondary.vue?vue&type=style&index=0&id=649d3052&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649d3052",
  null
  
)

export default component.exports